import React from 'react'
import { Link as ReactLink } from 'react-router-dom'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

export default function Mobile({ downloadUrl, isAndroid }) {

    const openPopup = () => {
        alert('App Store 출시예정')
    }
    
    return (
        <div style={{ width:'100vw', height: '100vh',  }}>
            {/* <ReactLink to="/event">
                <Box 
                    display="flex" 
                    flexDirection="column" 
                    alignItems="left" 
                    justifyContent="center" 
                    style={{ width:'100%', height:'154px',  backgroundImage: 'url("/images/events/banner_m.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
                    sx={{ p: 2 }}
                >
                    <span style={{ color: '#FFFFFF', fontSize: '15px', paddingBottom: '10px' }}>모아의 시작을 함께할 작가님을 찾습니다.</span>
                    <Box display="flex" flexDirection="row" style= {{ marginBottom: '10px' }}>
                        <span style={{ color: '#6F9BFF', fontSize: '28px', fontWeight: 'bold' }}>스타터 작가</span>
                        <span style={{ color: '#FFFFFF', fontSize: '28px', fontWeight: 'bold', paddingLeft: '10px' }}>신청하러 가기</span>
                    </Box>
                    <Box 
                        display="flex" 
                        flexDirection="column" 
                        alignItems="center" 
                        justifyContent="center" 
                        style={{ width:'131px', height: '34px', backgroundImage: 'url("/images/events/button_go_m.png")', textAlign: 'center', verticalAlign: 'middle' }}
                    >
                        <span style={{ color: '#FFFFFF', fontSize: '14px', fontWeight: 'bold' }}>GO</span>
                    </Box>
                </Box>
            </ReactLink> */}
            <Box style={{ 
                width:'100%', 
                height: '95%',
                backgroundImage: 'url("/images/mobile_1.jpg")', 
                backgroundRepeat: 'no-repeat', 
                backgroundPosition: 'center center',
                backgroundSize: '100% 100%', 
                position: 'relative'
            }}>
                <Box style={{ position: 'absolute', paddingLeft: '50%', paddingTop: '7%'}}>
                    {isAndroid &&
                        <Link href={downloadUrl} target='_blank'>
                            <span><img alt="logo" src="/images/download_button.png" width={'169'} height={'65'}/></span>
                        </Link>
                    }
                    {!isAndroid &&
                        <span onClick={openPopup}><img alt="logo" src="/images/download_button.png" width={'169'} height={'65'}/></span>
                    }
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    style={{ position: 'absolute', bottom: '50px', paddingLeft: '5%'}}
                >
                    <span><img alt="logo" src="/images/mooa_logo_white_m.png" width={'71'} height={'71'}/></span>
                    <span style={{color: '#ffffff', fontSize: '40px', paddingTop: '20px'}}>쉽고 빠른</span>
                    <span style={{color: '#ffffff', fontSize: '40px'}}>미술품 거래는</span>
                    <span style={{color: '#ffffff', fontSize: '40px'}}>모아</span>
                </Box>
            </Box>
            {/* 2page */}
            <Box 
                style={{ 
                    width:'100%', 
                    height: '95%',
                    backgroundImage: 'url("/images/mobile_2-new.png")', 
                    backgroundRepeat: 'no-repeat', 
                    backgroundPosition: 'center center',
                    backgroundSize: '100% 100%', 
                    position: 'relative'
                }}
            >
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    style={{ position: 'absolute', top: '50px', paddingLeft: '5%'}}
                >
                    <span><img alt="logo" src="/images/mooa_logo_black_m.png" width={'46'} height={'46'}/></span>
                    <span style={{fontSize: '23px', paddingTop: '10px'}}>안녕하세요</span>
                    <span style={{fontSize: '23px'}}>모두의 아트, 모아입니다.</span>
                    <span style={{fontSize: '16px', paddingTop: '20px'}}>모아는 국내 아마추어 작가</span>
                    <span style={{fontSize: '16px'}}>미술품 거래 중개 플랫폼입니다.</span>
                </Box>
            </Box>
            <Box style={{ 
                width:'100%', 
                height: '95%',
                backgroundImage: 'url("/images/mobile_3.jpg")', 
                backgroundRepeat: 'no-repeat', 
                backgroundPosition: 'center center',
                backgroundSize: '100% 100%', 
                position: 'relative'
            }}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    style={{ position: 'absolute', bottom: '50px', paddingLeft: '5%'}}
                >
                    <span style={{fontSize: '23px', paddingLeft: '10px'}}>손쉬운</span>
                    <span style={{fontSize: '23px', paddingLeft: '10px'}}>미술품 거래</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingTop: '20px'}}>판매자와 구매 희망자가</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px'}}>1:1 채팅을 통해</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', }}>편하게 대화할 수 있습니다.</span>
                </Box>
            </Box>
            <Box style={{ 
                width:'100%', 
                height: '95%',
                backgroundImage: 'url("/images/mobile_4.jpg")', 
                backgroundRepeat: 'no-repeat', 
                backgroundPosition: 'center center',
                backgroundSize: '100% 100%', 
                position: 'relative'
            }}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    style={{ position: 'absolute', bottom: '50px', paddingLeft: '5%'}}
                >
                    <span style={{fontSize: '23px', }}>취향을 담은</span>
                    <span style={{fontSize: '23px', }}>나만의 컬렉션</span>
                    <span style={{fontSize: '16px', paddingTop: '20px'}}>누구나 원하는 작품을 스크랩하여</span>
                    <span style={{fontSize: '16px', }}>자신만의 컬렉션을 제작할 수 있습니다.</span>
                </Box>
            </Box>
            <Box style={{ 
                width:'100%', 
                height: '100%', 
                backgroundImage: 'url("/images/mobile_5.jpg")', 
                backgroundRepeat: 'no-repeat', 
                backgroundPosition: 'center center',
                backgroundSize: '100% 100%', 
                position: 'relative'
            }}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    style={{ position: 'absolute', top: '100px', paddingLeft: '5%'}}
                >
                    <span style={{fontSize: '23px',}}>다양한 장르의</span>
                    <span style={{fontSize: '23px',}}>미술품</span>
                    <span style={{fontSize: '16px', paddingTop: '20px'}}>회화, 동양화, 디지털 아트, 조소 및 공예,</span>
                    <span style={{fontSize: '16px',}}>포토그래피, 섬유예술 등</span>
                    <span style={{fontSize: '16px',}}>다양한 장르의 작품들이 있습니다.</span>
                </Box>
            </Box>
            <Box style={{ 
                width:'100%', 
                height: '95%',
                backgroundImage: 'url("/images/mobile_6.jpg")', 
                backgroundRepeat: 'no-repeat', 
                backgroundPosition: 'center center',
                backgroundSize: '100% 100%', 
                marginBottom: '-1px',
            }}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    paddingTop='60px'
                    paddingLeft='5%'
                >
                    <span style={{fontSize: '23px', }}>잠들어 있는</span>
                    <span style={{fontSize: '23px', }}>나의 작품을</span>
                    <span style={{fontSize: '23px', }}>거래해 보세요.</span>
                </Box>
            </Box>
            <Box style={{ 
                width:'100%', 
                height: '370px',
                backgroundColor: '#353C46',
            }}>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    paddingLeft="5%"
                    paddingRight="5%"
                    paddingTop='20%'
                >
                    <img alt="logo" src="/images/mooa_logo_footer_m.png" width={'81'} height={'27'}/>
                    <span style={{color: '#ffffff', fontSize: '12px', }}>모두의 아트, 모아</span>
                </Box>
                <Divider sx={{ height: 2, m: 1, marginLeft: '5%', marginRight: '5%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
                <Box 
                    display="flex" 
                    flexDirection="column"
                    paddingLeft="5%"
                    paddingRight="5%"
                    paddingTop='20px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '12px'}}>러닝포인트 | 대표 : 박태훈 | 사업자등록번호 : 515-81-56247</span>
                    <span style={{color: '#B7B7B7', fontSize: '12px'}}>문의사항 oursartsmoah@gmail.com</span>
                    <span style={{color: '#B7B7B7', fontSize: '12px'}}>서울특별시 금천구 가산디지털1로 205-15, 1007호</span>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="3%"
                    paddingTop='20px'
                >
                    <Link href="https://www.instagram.com/art___mooa/" target='_blank'>
                        <img alt="logo" src="/images/instagram_logo_m.png" width={'30'} height={'28'}/>
                    </Link>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="5%"
                    paddingRight="5%"
                    paddingTop='10px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '12px'}}>©</span>
                    <span style={{color: '#B7B7B7', fontSize: '12px', paddingLeft: '5px'}}>MOOA</span>
                </Box>
            </Box>
        </div>
    )
}
